module.exports = __webpack_public_path__ + "static/media/LogoDefinitivo.0920c809.png";